<script>
    import {_hasOwnProperty, getCsrfParam, getCsrfToken} from '../js/utils.js'

    export let masters = []
    export let dates = []
    export let schedules = {}
    export let statuses = []

    function statusById(id) {
        for (const status of statuses) {
            if (status.id === id) {
                return status
            }
        }
        throw Error(`Status ${id} not found`)
    }

    function day(date) {
        return parseInt(date.substring(8))
    }

    function clickItem(masterId, date) {
        let status = null
        if (_hasOwnProperty(schedules, date)) {
            const a = schedules[date]
            if (_hasOwnProperty(a, masterId)) {
                status = a[masterId]
            }
        }
        if (status === statuses[1].id) {
            status = statuses[0].id
        } else {
            status = statuses[1].id
        }
        updateSchedule(masterId, date, status)
    }

    function updateSchedule(masterId, date, statusId) {
        const form = new FormData()
        form.append('master_id', masterId)
        form.append('date', date)
        form.append('status', statusId)
        form.append(getCsrfParam(), getCsrfToken())
        fetch('/schedule/update', {method: 'POST', body: form}).then(r => r.json()).then(r => {
            if (r.success) {
                if (!_hasOwnProperty(schedules, date)) {
                    schedules[date] = {}
                }
                schedules[date][masterId] = +r.model.status
                masters = masters
            }
        })
    }

    function cellValue(masterId, date) {
        const empty = ''
        if (!_hasOwnProperty(schedules, date)) {
            return empty
        }
        const i = schedules[date]
        if (!_hasOwnProperty(i, masterId)) {
            return empty
        }
        const statusId = i[masterId]
        const statusObj = statusById(statusId)
        return `<div class="day-label bg-${statusObj.color}" title="${statusObj.name}">&nbsp;</div>`
    }
</script>
<div>
    <table>
        {#each statuses as s}
            <tr>
                <td style="width: 15px">
                    <div class="day-label bg-{s.color}">&nbsp;</div>
                </td>
                <td>{s.name}</td>
            </tr>
        {/each}
    </table>
</div>
<div class="schedule-wrapper">
    <table class="table table-border table-hover">
        <thead>
        <tr>
            <th class="sticky-col">&nbsp;</th>
            {#each dates as date}
                <th>{day(date.date)}<br>{date.weekDay}</th>
            {/each}
        </tr>
        </thead>
        <tbody>
        {#each masters as master}
            <tr>
                <td class="sticky-col">{master.name}</td>
                {#each dates as date}
                    <td on:click|stopPropagation={() => clickItem(master.id, date.date)} on:keypress={() => {}}
                        class="day-slot">
                        {@html cellValue(master.id, date.date)}
                    </td>
                {/each}
            </tr>
        {/each}
        </tbody>
    </table>
</div>
